import { makeStyles } from "@material-ui/core";
import { COLORS } from "../../theme/colors";
import { styles } from "../../theme/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: styles.boxShadows.darks[6],
    borderRadius: theme.spacing(1),
    backgroundColor: COLORS.white,
  },
  hoverableRoot: {
    boxShadow: styles.boxShadows.darks[6],
    borderRadius: theme.spacing(1),
    backgroundColor: COLORS.white,
    "&:hover": {
      boxShadow: styles.boxShadows.purples[10],
    },
    cursor: "pointer",
  },
}));

export const ShaDowBox = ({ hoverable, children, active, style, fullHeight, border }) => {
  const classes = useStyles();

  return (
    <div
      className={hoverable ? classes.hoverableRoot : classes.root}
      style={{
        boxShadow: active ? styles.boxShadows.purples[10] : undefined,
        ...style,
        ...(fullHeight && { height: "100%" }),
        ...(border && { border: `1.5px solid ${COLORS.darks[0][15]}` }),
      }}
    >
      {children}
    </div>
  );
};
